export type ReasoningSummaryEventPayload =
  | {
      type: "response.reasoning_summary_text.done";
      text?: string;
    }
  | {
      type: "reasoning";
      summary?: Array<{ text?: string }>;
      summaryText?: string;
    };

export const isReasoningSummaryEventPayload = (
  payload: unknown
): payload is ReasoningSummaryEventPayload => {
  if (!payload || typeof payload !== "object") {
    return false;
  }

  const eventPayload = payload as { type?: unknown };

  return (
    eventPayload.type === "response.reasoning_summary_text.done" ||
    eventPayload.type === "reasoning"
  );
};

export const extractReasoningSummaryText = (
  payload: ReasoningSummaryEventPayload
): string | undefined => {
  if (payload.type === "response.reasoning_summary_text.done") {
    return payload.text?.trim();
  }

  if (payload.type === "reasoning") {
    const summaryText = payload.summaryText?.trim();
    if (summaryText) {
      return summaryText;
    }

    if (Array.isArray(payload.summary)) {
      const text = payload.summary
        .map((item) => (typeof item?.text === "string" ? item.text.trim() : ""))
        .filter(Boolean)
        .join(" ");
      return text.length > 0 ? text : undefined;
    }
  }

  return undefined;
};
